export default __webpack_public_path__ + "static/media/AIN.150ded1e.svg";